export interface BuildClassNameProps {
  styleClasses: string[];
  classes: {
    [key: string]: string;
  };
}

export function buildClassName(props: BuildClassNameProps): string {
  if (!props.styleClasses || props.styleClasses.length < 1) return '';

  let className = '';
  const appliedClasses: string[] = [];

  props.styleClasses.map((value: string) => {
    if (
      props.classes[value] &&
      appliedClasses.indexOf(props.classes[value]) < 0
    ) {
      className = className.length
        ? `${className} ${props.classes[value]}`
        : props.classes[value];

      appliedClasses.push(props.classes[value]);
    }
  });

  return className;
}
